<template>
  <div class="list-value container-fluid">
    <div class="row">
      <div class="col-lg-12">
        <div class="row">
          <div class="col-xs-12 page-header">
            <div class="col-xs-12 col-sm-10">
              <h2 class="small">
                {{ model.nome }}
                <!-- <small> {{ model.descricao }} </small> -->
              </h2>
            </div>
            <div class="col-xs-12 col-sm-2">
              <ul id="bandeiras">
                <li v-for="i in model.metas" :key="i.codigo">
                  <a
                    :href="i.link"
                    target="_blank"
                    :title="i.titulo"
                    data-toggle="popover"
                    data-placement="bottom"
                    data-trigger="hover"
                    :data-content="i.objetivo"
                  >
                    <img :src="concatPathImage(i.imagem_url)" />
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-12 col-sm-12">
            <list
              ref="vuetable"
              :show-empty="true"
              :reportTitle="model.DAD_DCNOME + '-valores'"
              :append-params="params"
              api-url="dado/valor/list"
              title="Listagem de valores"
              :fields="columns"
              :pageCollection="'userValues'"
            >
              <template slot="actions">
                <router-link
                  class="btn btn-default"
                  :to="{
                    name: 'user_dado_valor_save',
                    params: {
                      DAD_IDDADO: params.DAD_IDDADO
                    }
                  }"
                >
                  <font-awesome-icon :icon="'pen-square'"></font-awesome-icon>
                  Adicionar valor
                </router-link>
              </template>
              <!-- <template slot="rowrender" slot-scope="props">
                <div class="">
                  <router-link
                    v-if="isEditavel(props.rowData.DVA_DTDADOVALOR)"
                    class="btn btn-primary"
                    :to="{
                      name: 'user_dado_valor_save',
                      params: {
                        DAD_IDDADO: params.DAD_IDDADO,
                        DVA_IDDADOVALOR: props.rowData.DVA_IDDADOVALOR
                      }
                    }"
                  >
                    <font-awesome-icon :icon="'pen-square'"></font-awesome-icon>
                  </router-link>
                </div>
              </template> -->
              <template slot="rowrender" slot-scope="props">
                <div class="button-wrapper">
                  <button
                    title="Editar"
                    type="button"
                    class="btn btn-primary"
                    @click="editar(params, props.rowData)"
                  >
                    <font-awesome-icon :icon="'edit'"></font-awesome-icon>
                  </button>
                </div>
              </template>
            </list>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import userBase from '@/views/admin/dados/user/UserBase'
import list from '@/components/common/DataTable'
import { request } from '@/request'

export default {
  extends: userBase,
  data() {
    return {
      type: 'DADOVALOR',
      params: { DAD_IDDADO: 0 },
      columns: [],
      model: {}
    }
  },
  components: { list },
  created() {
    const me = this
    const { DAD_IDDADO } = this.$router.history.current.params
    this.params.DAD_IDDADO = DAD_IDDADO

    request
      .get(`dado/get/${DAD_IDDADO}`)
      .then(({ data }) => {
        me.model = data
      })
      .catch(error => {
        console.log(error.response)
      })

    this.createColumns()
  },
  methods: {
    /**
     * [isEditavel permite edição apenas dos valores do ano atual e do anterior]
     * @param  [date]  data [a data do lançamento do dado]
     * @return Boolean      [retorna true para valor que pode ser editado e false para o contrario]
     */
    isEditavel(data) {
      var anoAtual = new Date().getFullYear()
      var anoAnterior = anoAtual--
      var ano = new Date(
        data.replace(/(\d{2})\/(\d{2})\/(\d{4})/, '$2/$1/$3')
      ).getFullYear()
      return ano === anoAtual || ano === anoAnterior
    },
    createColumns() {
      this.columns = [
        {
          name: 'DVA_DTDADOVALOR',
          title: 'Data',
          dataClass: 'align-middle',
          filterable: true
        },
        {
          name: 'USER',
          title: 'Usuário',
          dataClass: 'align-middle',
          filterable: true
        },
        {
          name: 'VALOR',
          title: 'Valor',
          dataClass: 'align-middle',
          filterable: true
        },
        {
          name: '__slot:actions',
          title: 'Ações',
          titleClass: 'text-center col-md-3',
          dataClass: 'text-center'
        }
      ]
    },
    editar(dataParams, data) {
      this.$router.push({
        name: 'user_dado_valor_save',
        params: {
          DAD_IDDADO: dataParams.DAD_IDDADO,
          DVA_IDDADOVALOR: data.DVA_IDDADOVALOR
        }
      })
    }
  },
  updated() {
    window.jQuery('[data-toggle="popover"]').popover({})
  }
}
</script>

<style scoped>
#bandeiras {
  padding-left: 0px;
}
#bandeiras {
  list-style-type: none;
}
#bandeiras > li {
  max-width: 100px;
  float: left;
  margin-bottom: 30px;
}
#bandeiras > li > a > img {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/admin/dados/user/ListValue.vue